<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ model.headline }}
  </h5>
  <div class="d-flex d-lg-block d-xl-flex justify-content-between">
    <div class="flex-grow font-medium">
      {{ 'instrument-detail.instrument-dividends.year' | transloco }}
    </div>
    <div class="flex-grow text-right font-medium">
      {{ 'instrument-detail.instrument-dividends.yieldPercent' | transloco }}
    </div>
    <div class="flex-grow text-right font-medium">
      {{ 'instrument-detail.instrument-dividends.yieldAbs' | transloco }}
    </div>
  </div>
  <hr class="less-margin" />
  @for (item of model.dividends; track item.year; let last = $last) {
    <div class="d-flex d-lg-block d-xl-flex justify-content-between">
      <div class="flex-grow">
        {{ item.year }}
      </div>
      <div class="flex-grow text-right">{{ item.yieldPercent | number: '1.2-2' }} %</div>
      <div class="flex-grow text-right">{{ item.yieldAbs | number: '1.2-2' }} {{ item.symbol | currencySymbol }}</div>
    </div>
    @if (!last) {
      <hr class="less-margin" />
    }
  }
</div>
